var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useGiftsState } from '../../../store';
import { NotificationDrawer } from '../../NotificationDrawer';
import { AddGifts } from './AddGifts';
import { GiftsCtaSwitch } from './GiftsCtaSwitch';
import { AddGiftsDrawerNotificationDomain } from './notifications';
export const AddGiftsCtasWithDrawer = (props) => {
    var _a;
    const { onChange, customGiftSwitch, drawerId, open } = props, rest = __rest(props, ["onChange", "customGiftSwitch", "drawerId", "open"]);
    const { setActive, setActiveDrawer } = useGiftsState();
    return (_jsxs(_Fragment, { children: [(_a = customGiftSwitch === null || customGiftSwitch === void 0 ? void 0 : customGiftSwitch(rest)) !== null && _a !== void 0 ? _a : (_jsx(GiftsCtaSwitch, Object.assign({}, rest, { drawerId: drawerId }))), _jsx(NotificationDrawer, { notificationDomain: AddGiftsDrawerNotificationDomain, closeOnBackdrop: true, isOpen: open, onChange: (open) => {
                    if (!open) {
                        setActive(undefined);
                        setActiveDrawer(undefined);
                    }
                }, children: _jsx(AddGifts, Object.assign({}, rest, { onSubmit: () => {
                        setActiveDrawer(undefined);
                        setActive(undefined);
                    }, onChange: (productType, item) => {
                        onChange(productType, item);
                    } })) })] }));
};
//# sourceMappingURL=AddGiftsCtasWithDrawer.js.map